<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/admin/index' }">管理员管理</el-breadcrumb-item>
      <el-breadcrumb-item>管理员添加</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content">
        <el-form :data="formData" label-width="160px">
          <el-form-item label="管理员昵称">
            <el-col :span="12">
              <el-input size="small" v-model="formData.nickname" placeholder="请输入管理员昵称"></el-input>
            </el-col>
            <el-col :span="12">
              <span class="tips">*不可以修改</span>
            </el-col>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-col :span="12">
              <el-input size="small" v-model="formData.email" placeholder="请输入邮箱"></el-input>
            </el-col>
            <el-col :span="12">
              <span class="tips">*不可修改</span>
            </el-col>
          </el-form-item>
          <el-form-item label="权限组">
            <el-col :span="12">
              <el-select
               size="small"
                v-model="formData.show_group_ids"
                multiple
                placeholder="请选择"
                style="width: 100%;"
              >
                <el-option
                  v-for="(item, index) in group"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="save">保存</el-button>
            <el-button size="small" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        id: "",
        nickname: "",
        email: "",
        show_group_ids: [],
        group_ids: []
      },
      group: []
    };
  },
  methods: {
    save() {
      let _formData = this.formData;

      if(!_formData.nickname) {
        return this.$util.msg('请输入管理员昵称');
      }

      if(!_formData.email) {
        return this.$util.msg('请输入管理员邮箱');
      }

      if(_formData.show_group_ids.length <= 0) {
        return this.$util.msg('请选择权限组');
      }

      _formData.group_ids = _formData.show_group_ids.join(",");
      this.$ajax({
        type: "post",
        url: "/admin/save",
        data: _formData
      }).then(data => {
        this.$util.msg(data.msg, "success");
        setTimeout(() => {
          this.$router.push({ path: "/admin/index" });
        }, 1200);
      });
    }
  },
  mounted() {
    this.$ajax({
      url: "/admin/get-role"
    }).then(data => {
      this.group = data.data;
    });
  }
};
</script>
<style>
</style>